import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-project-detail',
  templateUrl: './app-project-detail.component.html',
  styleUrls: ['./app-project-detail.component.scss']
})
export class AppProjectDetailComponent implements OnInit {
  listTab: boolean = true;
  gridTab: boolean;
  constructor() { }

  ngOnInit(): void {
  }
  onMenuTab(number) {
    this.listTab = false;
    this.gridTab = false;

    if (number == '1') {
      this.listTab = true;
    }
    else if (number == '2') {
      this.gridTab = true;
    }
  }
}
